module.exports = __webpack_public_path__ + "static/media/nissan-go-drive.c52ce67c.png";